module.exports = __webpack_public_path__ + "55d4590deab93f9ccc60be5eec86162c.MP3";